const STORAGE_KEY = 'logistics.execution.workflowMode';

export type ExecutionWorkflowMode = 'simple' | 'advanced';

export function getExecutionWorkflowMode(): ExecutionWorkflowMode {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'advanced' ? 'advanced' : 'simple';
  } catch {
    return 'simple';
  }
}

export function setExecutionWorkflowMode(mode: ExecutionWorkflowMode): void {
  try {
    localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    /* ignore */
  }
}

export function isAdvancedExecutionMode(): boolean {
  return getExecutionWorkflowMode() === 'advanced';
}
